import { Box, Typography, Button, Paper } from "@mui/material";
import { useCookieConsent } from "../../contexts/CookieConsentContext";
import * as styles from "./cookieConsentStyles";

const CookieConsent: React.FC = () => {
    const { showBanner, acceptConsent, declineConsent } = useCookieConsent();

    if (!showBanner) {
        return null;
    }

    return (
        <Box sx={styles.overlay}>
            <Paper elevation={8} sx={styles.bannerContainer}>
                <Box sx={styles.contentContainer}>
                    <Typography variant="h6" sx={styles.title}>
                        Cookie-Einstellungen
                    </Typography>

                    <Typography variant="body2" sx={styles.description}>
                        Um aktuelle HSV-Spielinformationen anzuzeigen, werden Daten von externen Servern abgerufen. 
                        Dabei wird Ihre IP-Adresse übermittelt. Sie können jederzeit widersprechen.
                    </Typography>

                    <Box sx={styles.detailsContainer}>
                        <Typography variant="body2" sx={styles.details}>
                            <strong>Zweck:</strong> Abruf aktueller HSV-Spieltermine und -ergebnisse<br />
                            <strong>Verarbeitete Daten:</strong> IP-Adresse<br />
                            <strong>Rechtsgrundlage:</strong> Einwilligung (Art. 6 Abs. 1 lit. a DSGVO)
                        </Typography>
                    </Box>

                    <Box sx={styles.buttonContainer}>
                        <Button
                            variant="outlined"
                            onClick={declineConsent}
                            sx={styles.declineButton}
                        >
                            Ablehnen
                        </Button>
                        <Button
                            variant="contained"
                            onClick={acceptConsent}
                            sx={styles.acceptButton}
                        >
                            Akzeptieren
                        </Button>
                    </Box>
                </Box>
            </Paper>
        </Box>
    );
};

export default CookieConsent;
